<template>
  <div id="products-app">

    <div class="filters-wrap"
        v-if="productsBody.module && productsBody.ebook"
    >
      <div
        class="product-filter"
        v-on:click="filterChange('module')"
        :class="{ active: filter == 'module' }"
      >
        <span class="filter-title modules">{{ modules }}</span>
      </div>

      <div
        class="product-filter"
        v-on:click="filterChange('ebook')"
        :class="{ active: filter == 'ebook' }"
      >
        <span class="filter-title ebooks">{{ ebooks }}</span>
      </div>
    </div>

    <div class="products-listing">
      <div
        class="products-listing-el-wrap"
        v-for="product in productsBody[filter]"
        v-html="product"
      >
      </div>
    </div>


  </div>
</template>

<script>
import content from '@/translations/content'
import axios from 'axios'

export default {
  name: 'app',
  mixins: [content],
  data () {
    return {
      filter: 'module',
      products: {},
      productsBody: {}
    }
  },
  watch: {
    enabled (value) {
      const body = document.getElementsByTagName('body')
    }
  },
  methods: {
    filterChange (newFilter) {
      if (this.filter == newFilter) {
        this.filter = false
        this.productsIds = []
      } else {
        this.filter = newFilter
      }
    }
  },
  created () {
    const content = window.drupalSettings

    if (content) {
      this.products = content.productsParagraphIds.products
    }

    var productsBody = {}

    this.products.forEach(function (product) {
      let category = product[0]
      let id = product[1]


      if (productsBody[category] === undefined) {
        productsBody[category] = []
      }

      axios
        .get('/api/v1/products/renderById/' + id )
        .then(response => {
          productsBody[category].push( response.data.data.product_body )
        })

    })

    this.productsBody = productsBody
    if (Object.keys(productsBody).includes('ebook')){
      this.filter = 'ebook';
    }

    if (Object.keys(productsBody).includes('module')) {
      this.filter = 'module';
    }

    if (this.products.length === 1) {
      this.filter = this.products[0][0]
    }
  }
}
</script>

<style>
  .filters-wrap {
    display: flex;
    justify-content: space-around;
  }
</style>
